import Image from "next/image";
import Link from "next/link";
import { Title } from "@/components/ui/title";
import { Paragraph } from "@/components/ui/paragraph";

export default function HeyHo() {
  return (
    <section className="border-bottom-default">
      <div className="container py-10 mx-auto border-side-default">
        <Title>HeyHo! Let&apos;s Go!</Title>
        <Paragraph className="mt-2 mb-6">
          Join me in supporting the next wave of disruptors in AI and emerging technologies.
        </Paragraph>
        <Link
          href="https://heyho.ventures"
          target="_blank"
          className="block w-full rounded-2xl overflow-hidden hover:opacity-95 transition-opacity duration-200"
        >
          <Image
            src="/images/content/heyho-banner.png"
            alt="HeyHo Ventures - Artificial Intelligence & Emerging Technologies - Silicon Valley"
            width={1200}
            height={600}
            className="w-full h-auto"
            priority
          />
        </Link>
      </div>
    </section>
  );
}
